"use strict";

(function () {
  'use strict';

  function negativeAmount() {
    return function (amount) {
      if (amount && amount.substring(0, 1) === '-') {
        return '(' + amount.substring(1, amount.length) + ')';
      } else {
        return amount;
      }
    };
  }

  negativeAmount.$inject = [];
  angular.module('filter.negative-amount', []).filter('negativeAmount', negativeAmount);
})();